import { type ActiveState, createEntityStore, type EntityState } from '@datorama/akita';
import { type Report, type ReportingStandard } from 'types/models';

export interface ReportsState extends EntityState<Report>, ActiveState {
   statistics: any;
   standardsInReports: ReportingStandard['key'][];
}

const store = createEntityStore<ReportsState>({ statistics: undefined, standardsInReports: [] }, { resettable: true, name: 'reports' });

export default store;
